function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
/**
 * Validates feature flags and required draft doc models based on {@link BrickMetadata}
 * (either a {@link BrickConstructor} or a {@link BrickRegistryEntry}).
 *
 * Also provides a method for traversing the dependency graph to collect brick
 * dependencies based on the above validation.
 */ export var BrickDependencyCollector = /*#__PURE__*/ function() {
    "use strict";
    function BrickDependencyCollector(_getDependencies, _levelDependencyValidator) {
        _class_call_check(this, BrickDependencyCollector);
        _define_property(this, "_getDependencies", void 0);
        _define_property(this, "_levelDependencyValidator", void 0);
        this._getDependencies = _getDependencies;
        this._levelDependencyValidator = _levelDependencyValidator;
    }
    _create_class(BrickDependencyCollector, [
        {
            /**
   * Returns true if the Brick should not be activated because its required feature flags aren't present. It is not an
   * error to request activating such a Brick, but it will simply be silently not activated.
   */ key: "shouldInertBrick",
            value: function shouldInertBrick(_brickMetadata) {
                return false;
            }
        },
        {
            key: "collectBricksAndDependencies",
            value: /**
   * Map from an array of brick constructors to an array inclusive of the input array and all dependencies.
   *
   * @param constructorArray - Array of BrickConstructor
   * @returns Array of BrickConstructor containing the input constructorArray and all dependencies.
   * @throws if BrickLevelDependencyValidator fails
   */ function collectBricksAndDependencies(constructorArray) {
                var _this = this;
                return _async_to_generator(function() {
                    var bricksAndDependencies, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, brickConstructor;
                    return _ts_generator(this, function(_state) {
                        bricksAndDependencies = new Set();
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(_iterator = constructorArray[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                brickConstructor = _step.value;
                                // eslint-disable-next-line no-await-in-loop -- we want to process each brick in sequence
                                _this._collectBrickAndDependencies(brickConstructor, bricksAndDependencies);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return [
                            2,
                            _to_consumable_array(bricksAndDependencies)
                        ];
                    });
                })();
            }
        },
        {
            key: "_collectBrickAndDependencies",
            value: /**
   * Collects all the specified dependencies of the given brick recursively (including the brick itself).
   * @param brickMetadata - The class for the brick to get dependencies for.
   * @param dependencies - Used to collect the entire set of dependencies. Can pass in dependencies from
   *     previous calls to _collectBrickAndDependencies() in order to avoid re-recursing already-known dependencies.
   * @param ancestors - Should not be specified in the initial call. Used to pass the current ancestor chain
   *     down through recursive calls so we can detect circularities.
   * @param allFeatureFlags - the set of feature flags present in the app configuration.
   * @returns the set of all recursive dependencies of the brick, including itself.
   */ function _collectBrickAndDependencies(brickMetadata) {
                var dependencies = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Set(), ancestors = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
                if (ancestors.indexOf(brickMetadata) !== -1) {
                    throw new Error('Circular brick dependency detected for brick "'.concat(brickMetadata.id, '" - ancestors: [').concat(ancestors.join(", "), "]"));
                }
                if (dependencies.has(brickMetadata)) {
                    // We've already added dependencies of this brick - no need to re-recurse.
                    return;
                }
                if (this.shouldInertBrick(brickMetadata)) {
                    return;
                }
                dependencies.add(brickMetadata);
                ancestors.push(brickMetadata);
                var brickDependencies = this._getDependencies(brickMetadata);
                if (brickDependencies) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = brickDependencies[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var dependency = _step.value;
                            if (this._levelDependencyValidator && !this._levelDependencyValidator(brickMetadata.level, dependency.level)) {
                                throw new Error("Invalid brick level dependency from ".concat(brickMetadata.id, " (").concat(brickMetadata.level, ") to ").concat(dependency.id, " (").concat(dependency.level, ")"));
                            }
                            // eslint-disable-next-line no-await-in-loop -- we want to process each brick in sequence
                            this._collectBrickAndDependencies(dependency, dependencies, ancestors);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                ancestors.pop();
            }
        }
    ]);
    return BrickDependencyCollector;
}();

//# sourceMappingURL=BrickDependencyCollector.js.map